<template>
  <div class="figures-container" aria-hidden="true">
    <StaticAsset folder="images" file="character-stills_04.png" />
    <StaticAsset folder="images" file="character-stills_02.png" />
  </div>
</template>

<style scoped>
.figures-container {
  position: relative;

  > * {
    position: absolute;

    &:nth-child(1) {
      z-index: 2;
      top: 0;
    }

    &:nth-child(2) {
      z-index: 2;
      top: 2rem;
      left: 4rem;
    }
  }
}
</style>
